/**
 * Authoring subject-choice rules (`Capabilities/Assessment/Enrollment/SubjectChoiceRulesController.cs`), gated on
 * the structure permission because rules describe the curriculum. REST-shaped like `SubjectChoiceStore.ts`.
 */

import http from "../general/HttpClient";
import type { SubjectChoiceRule } from "./SubjectChoiceStore";

export type { SubjectChoiceRule };

export interface SubjectChoiceRuleDraft {
    qualificationID: string;
    qualificationLevelID: string;
    name: string;
    description?: string;
    appliesToAllSubjects: boolean;
    /** "Subjects" or "Credits". */
    measure: string;
    minimum?: number | null;
    maximum?: number | null;
    moduleIDs: string[];
}

const RULES_URL = "/api/assessment/enrollment/subject-choice-rules";

export const listSubjectChoiceRules = (qualificationID: string, qualificationLevelID: string): Promise<SubjectChoiceRule[]> =>
    http.get<SubjectChoiceRule[]>(RULES_URL, { params: { qualificationID, qualificationLevelID } }).then((r) => r.data);

export const createSubjectChoiceRule = (draft: SubjectChoiceRuleDraft): Promise<SubjectChoiceRule> =>
    http.post<SubjectChoiceRule>(RULES_URL, draft).then((r) => r.data);

export const updateSubjectChoiceRule = (id: string, draft: SubjectChoiceRuleDraft): Promise<SubjectChoiceRule> =>
    http.put<SubjectChoiceRule>(`${RULES_URL}/${encodeURIComponent(id)}`, draft).then((r) => r.data);

export const deleteSubjectChoiceRule = (id: string): Promise<void> =>
    http.delete(`${RULES_URL}/${encodeURIComponent(id)}`).then(() => undefined);

/** `ruleIDs` must name every rule of the qualification + level exactly once, in the new order. */
export const reorderSubjectChoiceRules = (
    qualificationID: string,
    qualificationLevelID: string,
    ruleIDs: string[]
): Promise<SubjectChoiceRule[]> =>
    http
        .put<SubjectChoiceRule[]>(`${RULES_URL}/order`, { ruleIDs }, { params: { qualificationID, qualificationLevelID } })
        .then((r) => r.data);
